var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.surveyHeader)?_c('div',{staticClass:"my-2"},[_c('div',{staticClass:"h4 text-center"},[_vm._v(_vm._s(_vm.surveyHeader.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.surveyHeader.description)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }